(() => {
  if (window.__novariaBundleCartActionsLoaded) return;
  window.__novariaBundleCartActionsLoaded = true;

  const rootPath = () => window.Shopify?.routes?.root || '/';
  const cartPageUrl = () => (typeof routes !== 'undefined' && routes.cart_url ? routes.cart_url : `${rootPath()}cart`);
  const cartJsonUrl = () => `${cartPageUrl()}.js`;
  const cartUpdateUrl = () => (typeof routes !== 'undefined' && routes.cart_update_url ? routes.cart_update_url : `${rootPath()}cart/update.js`);
  const prop = (item, key) => (item?.properties?.[key] == null ? '' : String(item.properties[key]));

  async function fetchJson(url, options = {}) {
    const headers = {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...(options.headers || {}),
    };
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options,
      headers,
    });
    const data = await response.json();
    if (!response.ok || data?.status || data?.errors) {
      throw new Error(data?.description || data?.message || data?.errors || 'Shopify no pudo actualizar el carrito.');
    }
    return data;
  }

  async function fetchCart() {
    return fetchJson(cartJsonUrl());
  }

  async function postUpdate(updates) {
    return fetchJson(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
  }

  async function fetchCanonicalDocument() {
    const url = new URL(window.location.href);
    url.hash = '';

    const response = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const html = await response.text();
    if (!response.ok) throw new Error('Shopify no pudo cargar el carrito actualizado.');

    return new DOMParser().parseFromString(html, 'text/html');
  }

  async function refreshDrawer(sourceDocument = null) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.renderContents) return false;

    const canonical = sourceDocument || (await fetchCanonicalDocument());
    const sourceDrawer = canonical.querySelector('cart-drawer');
    const sourceCartRoot = sourceDrawer?.querySelector('#CartDrawer');
    const sourceIcon = canonical.querySelector('#cart-icon-bubble');

    if (!sourceDrawer || !sourceCartRoot || !sourceIcon) {
      throw new Error('Shopify no devolvió el carrito actualizado después de eliminar el pack.');
    }

    drawer.renderContents({
      sections: {
        'cart-drawer': sourceDrawer.outerHTML,
        'cart-icon-bubble': `<div class="shopify-section">${sourceIcon.innerHTML}</div>`,
      },
    });
    return true;
  }

  async function refreshCartPage(sourceDocument = null) {
    const canonical = sourceDocument || (await fetchCanonicalDocument());
    const cartItems = document.querySelector('cart-items');

    if (!cartItems?.getSectionsToRender) {
      window.location.assign(cartPageUrl());
      return;
    }

    const sectionsToRender = cartItems.getSectionsToRender();
    let updatedAny = false;

    sectionsToRender.forEach((section) => {
      const currentRoot = document.getElementById(section.id);
      const sourceRoot = canonical.getElementById(section.id);
      if (!currentRoot || !sourceRoot) return;

      const currentTarget = section.selector
        ? currentRoot.querySelector(section.selector) || (currentRoot.matches?.(section.selector) ? currentRoot : null)
        : currentRoot;
      const sourceTarget = section.selector
        ? sourceRoot.querySelector(section.selector) || (sourceRoot.matches?.(section.selector) ? sourceRoot : null)
        : sourceRoot;

      if (!currentTarget || !sourceTarget) return;
      currentTarget.innerHTML = sourceTarget.innerHTML;
      updatedAny = true;
    });

    const currentIcon = document.querySelector('#cart-icon-bubble');
    const sourceIcon = canonical.querySelector('#cart-icon-bubble');
    if (currentIcon && sourceIcon) currentIcon.innerHTML = sourceIcon.innerHTML;

    if (!updatedAny) window.location.assign(cartPageUrl());
  }

  async function refreshCartSurface(button) {
    const canonical = await fetchCanonicalDocument();
    if (button.closest('cart-drawer')) {
      const rendered = await refreshDrawer(canonical);
      if (!rendered) window.location.assign(cartPageUrl());
      return;
    }
    await refreshCartPage(canonical);
  }

  async function removeBundle(bundleId, button) {
    if (!bundleId || button.disabled) return;
    button.disabled = true;
    const card = button.closest('[data-novaria-bundle-group]');
    const status = card?.querySelector('[data-novaria-bundle-cart-status]');
    if (status) status.textContent = 'Eliminando pack…';

    try {
      const cart = await fetchCart();
      const updates = {};
      cart.items.forEach((item) => {
        if (prop(item, '_novaria_bundle_id') === bundleId) updates[item.key] = 0;
      });

      if (Object.keys(updates).length) {
        // Shopify removes every real variant line that belongs to this bundle in one mutation.
        await postUpdate(updates);
      }

      // Read the committed storefront HTML from the exact current URL. Liquid remains
      // the source of truth for the empty/non-empty cart state, totals and cart badge.
      await refreshCartSurface(button);
    } catch (error) {
      console.error('Novaria Bundle remove:', error);
      if (status) status.textContent = error.message || 'No pudimos eliminar el pack.';
      button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-novaria-bundle-remove]');
    if (!button) return;
    event.preventDefault();
    removeBundle(button.dataset.novariaBundleRemove, button);
  });
})();
